export default {
    user:{},
    permissionKey:{},
    mutationFormTreeData: false,
    VLoading: {
        loading: false,
        loadingText: '数据加载中,请稍等！',
        loadingSpinner: 'el-icon-loading',
        loadingBackground: '#f3f3f4',
    }

}


// WEBPACK FOOTER //
// ./src/store/state.js